/* eslint-disable complexity */
import { useGetCartQuery } from './queries';

const useCart = (promotionId?: string | null | undefined) => {
	const { isLoading, data: cartQuery } = useGetCartQuery(promotionId);
	const isGuest = cartQuery?.cart.type === 'GUEST' || false;

	const cartSummary = cartQuery && {
		beforeDiscount:    cartQuery.cart.beforeDiscount,
		memberDiscount:    isGuest ? 0 : cartQuery.cart.memberDiscount,
		promotionDiscount: cartQuery.cart.promotionDiscount,
		finalPrice:        cartQuery.cart.finalPrice,
		itemCount:         cartQuery.cart.itemCount,
		shippingFee:       cartQuery.cart.shippingFee,
	};

	const cartItems = cartQuery?.cart.cartItems
		? cartQuery?.cart.cartItems.map(item => ({
			id:                  item.id,
			quantity:            item.quantity,
			product:             item.product,
			unitPrice:           item.unitPrice,
			discountPrice:       item.discountPrice,
			effectiveUnitPrice:  item.effectiveUnitPrice,
			effectiveTotalPrice: item.effectiveTotalPrice,
		}))
		: undefined;

	const promotions = cartQuery?.cart
		? cartQuery.promotions.map(promotion => ({
			...promotion,
			amount:        promotion.value,
			appliedAmount: promotion.appliedAmount,
		}))
		: [];

	return {
		isLoading,
		itemCount: cartQuery?.cart.itemCount,
		promotions,
		cartItems,
		cartSummary,
	};
};

export default useCart;